/**
 * Generates CSS styles for Froala content rendering.
 * Fixes font and spacing issues with character-based emoticons.
 * Uses theme values for consistency.
 */
export const getFroalaContentStyles = (): string => {
  return `
    /* Fix font and spacing issues with character-based emoticons in rendered content */
    /* These styles ensure consistent font rendering for Froala editor content */
    .fr-view span,
    .fr-view span *,
    .fr-element span,
    .fr-element span * {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      vertical-align: baseline !important;
    }

    /* Ensure emoji-specific spans don't affect surrounding text */
    .fr-view span[data-emoji],
    .fr-view .fr-emoticon,
    .fr-view span.fr-emoticon,
    .fr-element span[data-emoji],
    .fr-element .fr-emoticon,
    .fr-element span.fr-emoticon {
      display: inline !important;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      vertical-align: baseline !important;
    }

    /* Ensure paragraphs and divs maintain consistent styling */
    .fr-view p,
    .fr-view div,
    .fr-element p,
    .fr-element div {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
    }

    /* Ensure consistent font rendering */
    .fr-view,
    .fr-element {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      color: inherit !important;
    }
  `
}

/**
 * Injects Froala content rendering styles globally.
 * Call this once in your app to ensure styles are available everywhere.
 */
export const injectFroalaContentStyles = () => {
  if (typeof window === 'undefined') return

  const styleId = 'froala-content-rendering-styles'
  let styleElement = document.getElementById(styleId) as HTMLStyleElement | null

  if (!styleElement) {
    styleElement = document.createElement('style')
    styleElement.id = styleId
    styleElement.textContent = getFroalaContentStyles()
    document.head.appendChild(styleElement)
  }
}
